export default {
	timeout: {
		title: "Sessão prestes a expirar",
		message:
			"Você está inativo há algum tempo. Por segurança, sua sessão será encerrada em instantes.",
		countdown: "Encerrando em {seconds}s",
		continue: "Continuar conectado",
		logout: "Sair agora",
	},
	expiredByInactivity: "Sua sessão foi encerrada por inatividade.",
};
